export const logError = (error: Parameters<typeof console.error>[0]) => {
  if (process.env.NODE_ENV === "development") console.error(error, __filename);
};
